import {
  BUILDER_V2_INK,
  BUILDER_V2_MUTED_TEXT,
  BUILDER_V2_HOVER_BACKGROUND,
  BUILDER_V2_SELECTED_BACKGROUND
} from './builderV2Colors'

/** The block menu's icon size. */
export const BUILDER_V2_ICON_SIZE = '.875rem'

/**
 * The square icon button of the v2 builder: the block menu's option rows (`ButtonSelectOption`) and
 * the Format tab's text toolbar (#25443). Spread into a `makeStyles` rule and pass it to an
 * `IconButton`'s `classes.root`, so every builder icon button looks and hovers the same.
 *
 * `iconSize` makes the icon bigger (or smaller) without changing the rest of the button.
 */
export function builderV2IconButton({ iconSize = BUILDER_V2_ICON_SIZE }: { iconSize?: string } = {}) {
  return {
    borderRadius: 5,
    height: 26,
    width: 26,
    fontSize: '.75rem',
    fontWeight: 500,
    color: BUILDER_V2_MUTED_TEXT,
    '& svg': {
      fontSize: iconSize,
      color: BUILDER_V2_MUTED_TEXT
    },
    '&:hover': {
      background: BUILDER_V2_HOVER_BACKGROUND,
      color: BUILDER_V2_MUTED_TEXT
    }
  }
}

export const BUILDER_V2_ICON_BUTTON = builderV2IconButton()

export const BUILDER_V2_ICON_BUTTON_SELECTED = {
  background: BUILDER_V2_SELECTED_BACKGROUND,
  color: BUILDER_V2_INK,
  '& svg': {
    color: BUILDER_V2_INK
  },
  '&:hover': {
    background: BUILDER_V2_SELECTED_BACKGROUND,
    color: BUILDER_V2_INK
  }
}
